import constants from "../constants";
import { useEffect, useRef } from "react";
import CameraPlacementHooks from "./InstructionPage/CameraPlacementHooks";
import InstructionPageWizardHooks from "./InstructionPage/InstructionPageWizardHooks";

export default function WebSocketHooks() {
  const { verifyPic } = CameraPlacementHooks();
  const { handleNext } = InstructionPageWizardHooks();

  const wsRef = useRef(null);

  useEffect(() => {
    wsRef.current = new WebSocket("wss://c0ae-183-82-117-42.ngrok-free.app");
    // wsRef.current = new WebSocket("ws://192.168.0.202:3001");

    wsRef.current.onopen = () => {
      console.log("📱 WS connected from mobile");
    };

    wsRef.current.onerror = (err) => {
      console.error("❌ WS Error:", err);
    };

    wsRef.current.onmessage = (msg) => {
      if (parseInt(msg.data) === constants.WEBSOCKET.VERIFY_TOKEN) {
        return handleNext();
      }

      try {
        const data = JSON.parse(msg.data);

        if (data.type === constants.WEBSOCKET.VERIFY_PIC) {
          return verifyPic(data.filePath);
        } else {
          console.log("📩 WS message from server:", data);
        }
      } catch (e) {
        console.log("📩 WS message from server (non-JSON):", msg.data);
      }
    };

    return () => {
      wsRef.current?.close();
    };
  }, []);

  return { wsRef };
}
